import { DbRefs } from '../types';
import { createCollectionGroupOperations } from './apiOperations';

export const createCollectionGroupQuery = (dbRefs: DbRefs) => {
	return <T extends object>(collectionName: string) =>
		createCollectionGroupOperations<T>(collectionName, dbRefs);
};
